import { defineMessages } from 'react-intl.macro';

export const docEditMessages = defineMessages({
  queryStateFail: {
    id: 'docedit.alert.fail',
    defaultMessage: 'Akce selhala. Zkuste to prosím později.',
  },
  newAuthorTooltip: {
    id: 'docedit.edit.newauthor',
    defaultMessage: 'Vytvořit nového uživatele',
  },
  delete: {
    id: 'docedit.submitBtn.delete',
    defaultMessage: 'Smazat dokumentaci',
  },
  queryStateWaiting: {
    id: 'docedit.alert.waiting',
    defaultMessage: 'Čekejte prosím...',
  },
  submitQueryStateSuccess: {
    id: 'docedit.alert.submit.success',
    defaultMessage: 'Změny uloženy.',
  },
  submitQueryStateFail: {
    id: 'docedit.alert.submit.fail',
    defaultMessage: 'Uložení změn se nepovedlo. Zkuste to prosím později.',
  },
  signQueryStateFail: {
    id: 'docedit.alert.sign.fail',
    defaultMessage: 'Příjem selhal. Zkuste to prosím později.',
  },
  loadQueryStateFail: {
    id: 'docedit.alert.load.fail',
    defaultMessage: 'Načtení dokumentace selhalo. Zkuste to prosím později.',
  },
  checkQueryStateWaiting: {
    id: 'docedit.check.checkQueryStateWaiting',
    defaultMessage: 'Probíhá kontrola dokumentace',
  },
  checkQueryStateFail: {
    id: 'docedit.check.checkQueryStateFail',
    defaultMessage: 'Kontrola dokumentace selhala',
  },
  docEditBtn: {
    id: 'docedit.check.docEditBtn',
    defaultMessage: 'Přejít k podání',
  },
  download: {
    id: 'document.check.download',
    defaultMessage: 'Stáhnout soubory',
  },
  closeQueryStateFail: {
    id: 'docedit.alert.close.fail',
    defaultMessage: 'Uzavření selhalo. Zkuste to prosím později.',
  },
  finalCloseQueryStateFail: {
    id: 'docedit.alert.final.close.fail',
    defaultMessage: 'Zapracování dvojic identifikátorů selhalo. Zkuste to prosím později.',
  },
  destroyQueryStateFail: {
    id: 'docedit.alert.destroy.fail',
    defaultMessage: 'Smazání selhalo. Zkuste to prosím později.',
  },
  editQueryStateFail: {
    id: 'docedit.alert.edit.fail',
    defaultMessage: 'Požadavek na editaci selhal. Zkuste to prosím později.',
  },
  rejectQueryStateFail: {
    id: 'docedit.alert.reject.fail',
    defaultMessage: 'Odmítnutí selhalo. Zkuste to prosím později.',
  },
  importQueryStateFail: {
    id: 'docedit.alert.import.fail',
    defaultMessage: 'Přijmutí selhalo. Zkuste to prosím později.',
  },
  checkSvuCrossKrajQueryStateFail: {
    id: 'docedit.alert.checkSvuCrossKraj.fail',
    defaultMessage: 'Ověření přesahu do sousedního kraje selhalo. Zkuste to prosím později.',
  },
  potvrdZapracovatelnostQueryStateFail: {
    id: 'docedit.alert.potvrdZapracovatelnost.fail',
    defaultMessage: 'Převzetí krajem selhalo. Zkuste to prosím později.',
  },
  potvrdZapracovatelnostConfirm: {
    id: 'docedit.alert.potvrdZapracovatelnost.confirm',
    defaultMessage:
      'Chcete GAD opravdu přesunout do stavu Převzatá krajem? Posun do tohoto stavu je nevratný.',
  },
  interruptQueryStateFail: {
    id: 'docedit.alert.interrupt.fail',
    defaultMessage: 'Přerušení selhalo. Zkuste to prosím později.',
  },
  checkInterruptBtn: {
    id: 'docedit.check.checkInterruptBtn',
    defaultMessage: 'Přerušit kontrolu dokumentace',
  },
  sendToDMVSQueryStateFail: {
    id: 'docedit.alert.sendToDMVS.fail',
    defaultMessage:
      'Odeslání do IS DMVS selhalo. Zkontrolujte prosím přílohu, která musí být označená jako "Aktualizační data" a musí být ve formátu ZIP, nebo zkuste akci spustit později.',
  },
  sendToDMVSDtmQueryStateFail: {
    id: 'docedit.alert.sendToDMVSDtm.fail',
    defaultMessage:
      'Odeslání do IS DMVS selhalo. Zkontrolujte prosím přílohu, která musí být označená jako "Rozsah editace" v části Soubory určené pro druhou stranu',
  },
  canNotEdit: {
    id: 'docedit.warning.canNotEdit',
    defaultMessage: 'Pro přístup do editace musíte být přiřazený jako editor.',
  },
  synchronizationQueryStateFail: {
    id: 'docedit.alert.synchronization.fail',
    defaultMessage: 'Synchronizační akce selhala. Zkuste to prosím později.',
  },
  fileDownloadError: {
    id: 'docedit.alert.fileDownloadError',
    defaultMessage: 'Soubor nebyl vytvořen.',
  },
  copyQueryStateFail: {
    id: 'docedit.alert.copy.fail',
    defaultMessage: 'Vytvoření podkladu pro nové podání selhalo. Zkuste to prosím později.',
  },
  crossDataToDmvsQueryStateFail: {
    id: 'docedit.alert.crossDataToDmvs.fail',
    defaultMessage: 'Předání dat na SVÚ selhalo. Zkuste to prosím později.',
  },
  sendToCounterpartNotCheckedFail: {
    id: 'docedit.alert.sendToCounterpart.notChecked',
    defaultMessage: 'Data byla po poslední kontrole upravena. Spusťte kontrolu a odešlete znovu.',
  },
  sendToDmvsConflictFail: {
    id: 'docedit.alert.sendToDmvs.conflict',
    defaultMessage: 'Odeslání do IS DMVS už u této dokumentace proběhlo nebo právě probíhá.',
  },
  linkToDmvsGadWarning: {
    id: 'docedit.alert.linkToDmvsGadWarning',
    defaultMessage: 'Dokumentace nemá párovou GAD.',
  },
  linkToDtmkKadWarning: {
    id: 'docedit.alert.linkToDtmkKadWarning',
    defaultMessage:
      'Dokumentace nemá párovou KAD v komponentě pro správu aktualizačních dokumentací.',
  },
});

export const validatorMessages = defineMessages({
  authorError: {
    id: 'docedit.author.error',
    defaultMessage: 'vyberte zpracovatele',
  },
  geodesistError: {
    id: 'docedit.geodesist.error',
    defaultMessage: 'vyberte oprávněného geodeta',
  },
  subjektError: {
    id: 'docedit.subjekt.error',
    defaultMessage: 'vyberte subjekt',
  },
  cadastersError: {
    id: 'docedit.cadasters.error',
    defaultMessage: 'vyberte katastrální území',
  },
  buildingDescriptionError: {
    id: 'docedit.name.error',
    defaultMessage: 'vyplňte popis stavby',
  },
  ownerNameError: {
    id: 'docedit.owner_name.error',
    defaultMessage: 'vyplňte jméno vlastníka / investora',
  },
  ownerIcoError: {
    id: 'docedit.owner_ico.error',
    defaultMessage: 'vyplňte IČO nebo rodné číslo vlastníka / investora',
  },
  processorNameError: {
    id: 'docedit.processor_name.error',
    defaultMessage: 'vyplňte jméno zpracovatele',
  },
  processorIcoError: {
    id: 'docedit.processor_ico.error',
    defaultMessage: 'vyplňte IČO nebo rodné číslo zpracovatele',
  },
  objectDescriptionError: {
    id: 'docedit.description.error',
    defaultMessage: 'vyplňte objekt',
  },
  hasPlanimetryError: {
    id: 'docedit.has_planimetry.error',
    defaultMessage: 'vyberte kategorii stavby',
  },
  hasUtilitiesError: {
    id: 'docedit.has_utilities.label',
    defaultMessage: 'vyberte kategorii stavby',
  },
  utilitiesTypeError: {
    id: 'docedit.utilities_type.error',
    defaultMessage: 'vyberte inženýrské sítě',
  },
  locationError: {
    id: 'docedit.location.error',
    defaultMessage: 'vyplňte umístění',
  },
  subjectError: {
    id: 'docedit.subject.error',
    defaultMessage: 'vyplňte subjekt',
  },
  dataTypeError: {
    id: 'docedit.data_type.error',
    defaultMessage: 'vyberte typ dokumentace',
  },
});

export const docEditButtonsMsg = defineMessages({
  docBtnRemove: {
    id: 'docDetail.btn.remove',
    defaultMessage: 'Smazat',
  },
  docBtnCancel: {
    id: 'docDetail.btn.cancel',
    defaultMessage: 'Stornovat',
  },
  docBtnSubmit: {
    id: 'docDetail.btn.submit',
    defaultMessage: 'Podat',
  },
  docBtnReject: {
    id: 'docDetail.btn.reject',
    defaultMessage: 'Odmítnout',
  },
  docBtnAccept: {
    id: 'docDetail.btn.accept',
    defaultMessage: 'Přijmout',
  },
  docBtnDownloadProtocol: {
    id: 'docDetail.btn.downloadProtocol',
    defaultMessage: 'protokol o přijetí podkladu',
  },
  docBtnDownloadProtocolToSign: {
    id: 'docDetail.btn.downloadProtocolToSign',
    defaultMessage: 'protokol k podpisu',
  },
  docBtnUploadSignedProtocol: {
    id: 'docDetail.btn.uploadSignedProtocol',
    defaultMessage: 'Nahrát podepsaný protokol',
  },
  docBtnMapEdit: {
    id: 'docDetail.btn.mapEdit',
    defaultMessage: 'Editovat mapu',
  },
  docBtnMapReview: {
    id: 'docDetail.btn.mapReview',
    defaultMessage: 'Zobrazit mapu',
  },
  docBtnMapReview3d: {
    id: 'docDetail.btn.mapReview3d',
    defaultMessage: 'Zobrazit mapu 3D',
  },
  docBtnMapReviewShort: {
    id: 'docDetail.btn.mapReviewShort',
    defaultMessage: 'Zobrazit',
  },
  docBtnMapEditShort: {
    id: 'docDetail.btn.mapEditShort',
    defaultMessage: 'Editovat',
  },
  docUploadProtocolFileNameError: {
    id: 'docDetail.signedProtocol.upload.fileNameError',
    defaultMessage:
      'Název souboru s podepsaným protokolem neodpovídá dané přejímce. Přejete si přesto pokračovat?',
  },
  docBtnDownloadLog: {
    id: 'docDetail.btn.downloadLog',
    defaultMessage: 'log importu',
  },
  docBtnDownloadCloseLog: {
    id: 'docDetail.btn.downloadCloseLog',
    defaultMessage: 'log uzavření',
  },
  docBtnDownloadImportLog: {
    id: 'docDetail.btn.downloadImportLog',
    defaultMessage: 'log importu',
  },
  docBtnDownloadSynchronizedLog: {
    id: 'docDetail.btn.downloadSynchronizedLog',
    defaultMessage: 'log synchronizace',
  },
  docBtnDownloadLogDmvs: {
    id: 'docDetail.btn.downloadLogDmvs',
    defaultMessage: 'log kraje/SVÚ',
  },
  docBtnSave: {
    id: 'docDetail.btn.save',
    defaultMessage: 'Uložit',
  },
  docBtnClose: {
    id: 'docDetail.btn.close',
    defaultMessage: 'Uzavřít',
  },
  docBtnFinalClose: {
    id: 'docDetail.btn.finalClose',
    defaultMessage: 'Zapracovat dvojici identifikátorů',
  },
  docBtnEdit: {
    id: 'docDetail.btn.edit',
    defaultMessage: 'Editovat',
  },
  docBtnSendCrossDataToDmvs: {
    id: 'docDetail.btn.sendCrossDataToDmvs',
    defaultMessage: 'Předat data přeshraniční dokumentace',
  },
  docBtnSendCrossDataToSvu: {
    id: 'docDetail.btn.sendCrossDataToSvu',
    defaultMessage: 'Odeslat na SVÚ',
  },
  docBtnSubmitClick: {
    id: 'docDetail.btn.submitClick',
    defaultMessage: 'Případné změny ve formuláři nebudou uloženy. Přejete si pokračovat?',
  },
  docBtnEditCheck: {
    id: 'docDetail.btn.editCheck',
    defaultMessage: 'Zkontrolovat',
  },
  docBtnImport: {
    id: 'docDetail.btn.import',
    defaultMessage: 'Přijmout',
  },
  docBtnCeproImport: {
    id: 'docDetail.btn.ceproImport',
    defaultMessage: 'Importovat',
  },
  docBtnBbImport: {
    id: 'docDetail.btn.bbImport',
    defaultMessage: 'Importovat',
  },
  docBtnRetry: {
    id: 'docDetail.btn.retry',
    defaultMessage: 'Opakovat',
  },
  docBtnInterrupt: {
    id: 'docDetail.btn.interrupt',
    defaultMessage: 'Přerušit',
  },
  docBtnNotifyClose: {
    id: 'docDetail.btn.notifyClose',
    defaultMessage: 'Opakovat',
  },
  docBtnSendToDMVS: {
    id: 'docDetail.btn.docBtnSendToDMVS',
    defaultMessage: 'Odeslat do IS DMVS',
  },
  docBtnSynchronize: {
    id: 'docDetail.btn.docBtnSynchronize',
    defaultMessage: 'Synchronizovat',
  },
  docBtnRequestSynchronizationData: {
    id: 'docDetail.btn.docBtnRequestSynchronizationData',
    defaultMessage: 'Zažádat o synchronizační data',
  },
  docBtnCloseCrossDataToDmvs: {
    id: 'docDetail.btn.docBtnCloseCrossDataToDmvs',
    defaultMessage: 'Předat informaci o uzavření',
  },
  docBtnDelegate: {
    id: 'docDetail.btn.delegate',
    defaultMessage: 'Delegovat na SVÚ',
  },
  docBtnPotvrdZapracovatelnost: {
    id: 'docDetail.btn.potvrdZapracovatelnost',
    defaultMessage: 'Převzít krajem',
  },
  docBtnRetryPotvrdZapracovatelnost: {
    id: 'docDetail.btn.retryPotvrdZapracovatelnost',
    defaultMessage: 'Znovu uzavřít',
  },
  docBtnCheckDmvsPendingPozadavky: {
    id: 'docDetail.btn.checkDmvsPendingPozadavky',
    defaultMessage: 'Obnovit proces',
  },
  docBtnLinkToDmvsGad: {
    id: 'docDetail.btn.linkToDmvsGad',
    defaultMessage: 'Párová dokumentace',
  },
  docBtnLinkToDtmkKad: {
    id: 'docDetail.btn.linkToDtmkKad',
    defaultMessage: 'Párová dokumentace',
  },
  docBtnCheckSvuCrossKraj: {
    id: 'docDetail.btn.checkSvuCrossKraj',
    defaultMessage: 'Ověřit přesah do sousedního kraje',
  },
  docBtnDownloadDigitalniOsvedceni: {
    id: 'docDetail.btn.downloadDigitalniOsvedceni',
    defaultMessage: 'osvědčení o digitálním úkonu',
  },
});
